var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 120,
    viewBox: "0 0 137 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 120,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MacBook Pro 14\" - 4"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -334,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stair",
    opacity: 0.770813,
    d: "M14.8685 71.2889L14.1104 69.9946L12.8161 70.7528L-11.7242 85.128L-25.3412 61.882L75.4083 2.86476L134.426 103.614L111.18 117.231L96.8044 92.6911L96.0462 91.3968L94.7519 92.155L70.2117 106.53L55.8365 81.99L55.0783 80.6957L53.784 81.4539L29.2438 95.8291L14.8685 71.2889Z",
    fill: "#27AE60",
    stroke: "#111111",
    strokeWidth: 3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: 756,
    y1: -334,
    x2: 756,
    y2: 648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -334,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStair);
export default __webpack_public_path__ + "static/media/stair.8dfcfa79cc75e1a8c1208cec5e8a653a.svg";
export { ForwardRef as ReactComponent };